import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagingComponent } from './paging.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [PagingComponent],
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, FormsModule, FontAwesomeModule],
  exports: [PagingComponent],
})
export class PagingModule {}
